import React from 'react';
import { hot } from 'react-hot-loader';
import { formatPrice } from '../../utils/string';
import s from './Price.scss';

const Price = ({ price, setup, soldOut = false, product = false, checkout = false }) => {
	if (price[setup.currency]) price = price[setup.currency];
	const isOnSale = !!price.compareAtPrice && price.price !== price.compareAtPrice;

	if (soldOut && product) return <span className={[s.price, s.price__soldOutProduct].join(' ')}><s>{ isOnSale ? formatPrice(setup, price.compareAtPrice) : formatPrice(setup, price.price) }</s></span>;
	if (soldOut) return <span className={[s.price, s.price__soldOut].join(' ')}><s>{ isOnSale ? formatPrice(setup, price.compareAtPrice) : formatPrice(setup, price.price) }</s></span>;
	if (product) return <span className={[s.price, (isOnSale ? s.price__sale : null)].join(' ')}>{ formatPrice(setup, price.price) }</span>;
	return (
		<span className={[s.price, (product ? s.price__product : null), (checkout ? s.price__checkout : null)].join(' ')}>
			{ isOnSale ? <><s className={s.price_oldPrice}>{ formatPrice(setup, price.compareAtPrice) }</s> <span className={s.price_sale}>{ formatPrice(setup, price.price) }</span></> : formatPrice(setup, price.price) }
		</span>
	);
};

export default hot(module)(Price);
